import _toConsumableArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import { useState } from 'react';
import { useIntl } from 'react-intl';

var formatError = function formatError(mesure, value, constraint, label) {
  return {
    id: "image-modal.errors.".concat(mesure),
    values: {
      constraint: constraint,
      value: value,
      label: label
    }
  };
};

export var useValidators = function useValidators(_ref) {
  var imageConstraints = _ref.imageConstraints,
      imageRatio = _ref.imageRatio;
  var intl = useIntl();

  var _useState = useState([]),
      constraintErrors = _useState[0],
      setConstraintErrors = _useState[1];

  var imageLabel = (imageConstraints === null || imageConstraints === void 0 ? void 0 : imageConstraints.imageLabelId) === undefined ? '' : '"'.concat(intl.formatMessage({
    id: imageConstraints.imageLabelId
  }), '" '); // used as dynamic text into a translation

  var validateMinWidthAndHeightWithRatio = function validateMinWidthAndHeightWithRatio(image) {
    var _imageConstraints$con;

    var constraint = (_imageConstraints$con = imageConstraints === null || imageConstraints === void 0 ? void 0 : imageConstraints.constraints.minWidth) !== null && _imageConstraints$con !== void 0 ? _imageConstraints$con : 0;

    if (constraint > 0 && image.width < constraint) {
      setConstraintErrors(function (prevValue) {
        return [].concat(_toConsumableArray(prevValue), [formatError('min-width', image.width, constraint, imageLabel)]);
      });
      return false;
    }

    var minHeight = imageRatio === undefined ? 0 : constraint / imageRatio;

    if (minHeight > 0 && image.height < minHeight) {
      setConstraintErrors(function (prevValue) {
        return [].concat(_toConsumableArray(prevValue), [formatError('min-height', image.height, minHeight, imageLabel)]);
      });
      return false;
    }

    return true;
  };

  var validateMaxWidth = function validateMaxWidth(image) {
    var _imageConstraints$con2;

    var constraint = (_imageConstraints$con2 = imageConstraints === null || imageConstraints === void 0 ? void 0 : imageConstraints.constraints.maxWidth) !== null && _imageConstraints$con2 !== void 0 ? _imageConstraints$con2 : 0;

    if (constraint > 0 && image.width > constraint) {
      setConstraintErrors(function (prevValue) {
        return [].concat(_toConsumableArray(prevValue), [formatError('max-width', image.width, constraint, imageLabel)]);
      });
      return false;
    }

    return true;
  };

  return {
    validators: {
      minWidth: validateMinWidthAndHeightWithRatio,
      maxWidth: validateMaxWidth
    },
    errors: constraintErrors,
    resetErrors: function resetErrors() {
      return setConstraintErrors([]);
    }
  };
};